import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a321b98c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_date_picker = _resolveComponent("app-date-picker")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.$localize('profile.edit.education.title')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileStore.bufferProfile.educations, (education, idx) => {
      return (_openBlock(), _createBlock(_component_Form, {
        as: "el-form",
        key: idx
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_input, {
            modelValue: education.school,
            "onUpdate:modelValue": ($event: any) => ((education.school) = $event),
            name: "school",
            label: _ctx.$localize('profile.edit.education.school'),
            placeholder: _ctx.$localize('profile.edit.education.add.school')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder"]),
          _createVNode(_component_app_input, {
            modelValue: education.degree,
            "onUpdate:modelValue": ($event: any) => ((education.degree) = $event),
            name: "degree",
            label: _ctx.$localize('profile.edit.education.degree'),
            placeholder: _ctx.$localize('profile.edit.education.add.degree')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_app_date_picker, {
              modelValue: education.startDate,
              "onUpdate:modelValue": ($event: any) => ((education.startDate) = $event),
              type: "month",
              name: "startDate",
              label: _ctx.$localize('profile.edit.education.start_date'),
              placeholder: _ctx.$localize('profile.edit.education.add.start_date'),
              format: "MM/YYYY",
              class: "mr-10",
              "disabled-date": _ctx.disabledStartDateFactory(idx)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder", "disabled-date"]),
            _hoisted_2,
            _createVNode(_component_app_date_picker, {
              modelValue: education.endDate,
              "onUpdate:modelValue": ($event: any) => ((education.endDate) = $event),
              type: "month",
              name: "endDate",
              label: _ctx.$localize('profile.edit.education.end_date'),
              placeholder: _ctx.$localize('profile.edit.education.add.end_date'),
              format: "MM/YYYY",
              "disabled-date": _ctx.disabledEndDateFactory(idx)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder", "disabled-date"])
          ])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    (_ctx.isEducationFilled)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addEducation && _ctx.addEducation(...args)))
        }, _toDisplayString(_ctx.$localize('profile.edit.education.button.add')), 1))
      : _createCommentVNode("", true)
  ], 64))
}